export default __webpack_public_path__ + "static/media/peugeot.a1d6feec.png";